import { AUTHORIZATION_TYPE } from '../utils/authorization'
import { MAX_INPUT_LENGTH, REGEXP_CHARACTERS_BLOCK } from './constant'

export const removeSpecials = (value) =>
  value
    .slice(0, MAX_INPUT_LENGTH)
    .split('')
    .filter((item) => !REGEXP_CHARACTERS_BLOCK.includes(item))
    .join('')

export const handleSelectAll = (prevState, newState, listUnselect) => {
  if (!listUnselect) {
    newState.forEach((item) => {
      if (!prevState.includes(item)) {
        prevState.push(item)
      }
    })
    return prevState
  } else {
    newState.forEach((item) => {
      if (!prevState.includes(item)) {
        prevState.push(item)
      }
    })
    return prevState.filter((item) => !listUnselect.includes(item))
  }
}

export const handleUnSelectAll = (prevState, newState) => {
  return prevState.filter((item) => !newState.includes(item))
}

export const getIsLock = (userType, component) => {
  return component[userType.userTypeId] === AUTHORIZATION_TYPE.DISABLE
}

//
export const checkIsSelectAll = (listIdAll, objSelected) => {
  const listIdSelect = Object.keys(objSelected)
    .filter((item) => objSelected[item])
    .map(Number)

  return !listIdAll.some((ele) => !listIdSelect.includes(ele))
}

export const getListIdSelectByObj = (objSelected) =>
  Object.keys(objSelected)
    .filter((item) => objSelected[item])
    .map(Number)

export const handleSelectAllIdInTable = (prevState, newListId, isSelect) => {
  newListId.forEach((item) => {
    prevState[item] = isSelect
  })
  return prevState
}
